import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import setUiMessage from '../../../Utilities/Tostify';
import Button from '../../Button';
import AddTaskPopup from './AddTaskPopup';
import RecurranceUpdateInstancePopup from '../Appointment/RecurranceUpdateInstancePopup';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';

function WeeklySchedule({ handleClose = () => {}, reload }) {
  const { user } = useSelector((state) => state.auth);
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const [allData, setAllData] = useState([]);
  const [provider, setProvider] = useState(
    user?.userType === '1'
      ? user?.id
      : user?.glsstsettins?.default_provider_book_an_appointment,
  );
  const [weeklyScheduleData, setWeeklyScheduleData] = useState([]);
  const [scheduleStartDate, setScheduleStartDate] = useState(null);
  const [scheduleEndDate, setScheduleEndDate] = useState(null);
  const [scheduleType, setScheduleType] = useState(0);
  const [overrideId, setOverrideId] = useState(0);
  const [addTask, setAddTask] = useState(false);

  const [recurranceInstancePopup, setRecurranceInstancePopup] = useState(false);
  const [updateInstanceFlag, setUpdateInstanceFlag] = useState(false);
  const [askRecurrData, setAskRecurrData] = useState('');
  const [editTaskData, setEditTaskData] = useState('');
  const [taskData, setTaskData] = useState('');
  const [conFirmDelete, setConFirmDelete] = useState({
    status: false,
    deltaskData: '',
    delType: '0',
  });

  useEffect(() => {
    (async () => {
      const response = await post('api/auth/getProviderWeeklySchedule', {
        provider: provider || user?.id,
        loginUserId: user?.id,
        scheduleType: scheduleType,
        //overrideId: overrideId,
      });
      if (response.status === 200) {
        if (scheduleType === 0 || scheduleType === 1) {
          setAllData(response.data || []);

          setScheduleStartDate(
            response.data?.sheduleStartDate
              ? new Date(response.data?.sheduleStartDate)
              : null,
          );
          setScheduleEndDate(
            response.data?.sheduleEndDate
              ? new Date(response.data?.sheduleEndDate)
              : null,
          );

          setOverrideId(
            response.data?.scheduleData
              ? response.data?.scheduleData?.override_id
              : 0,
          );
          const chkInptData =
            response.data?.proHours &&
            response.data?.proHours.reduce((acc, data, i) => {
              let finalObj = {
                dayId: data?.dayId,
                dayName: data?.dayName,
                fbsTime: data?.fbs,
                fbName: data?.fbName,
                fbeTime: data?.fbe,
                sbsTime: data?.sbs,
                sbeTime: data?.sbe,
                sbName: data?.sbName,
              };
              let obj = data.proHrsSetting.map((item, i) => {
                return {
                  id: item?.id,
                  clinic_id: item?.clinic_id,
                  provider_id: item?.provider_id,
                  day_id: item?.day_id,
                  location_code: item?.location_code,
                  isClose: item?.is_closed,
                  openTime: item?.open_time,
                  closeTime: item?.close_time,
                  is_telemedicine: item?.is_telemedicine,
                };
              });
              finalObj = { ...finalObj, lockData: obj };
              return [...acc, finalObj];
            }, []);
          //console.log(chkInptData);
          setWeeklyScheduleData(chkInptData);
        } else if (scheduleType === 2) {
          setAllData(response.data || []);
        }
      }
    })();
  }, [provider, user?.id, reload, scheduleType]);

  const handleChkBox = (e, i, j) => {
    let updatedData = [...weeklyScheduleData];
    if (e.target.checked) {
      updatedData[i].lockData[j].isClose = '1';
    } else {
      updatedData[i].lockData[j].isClose = '0';
    }
    setWeeklyScheduleData(updatedData);
  };
  const handleTelMedChkBox = (e, i, j) => {
    let updatedData = [...weeklyScheduleData];
    if (e.target.checked) {
      updatedData[i].lockData[j].is_telemedicine = '1';
    } else {
      updatedData[i].lockData[j].is_telemedicine = '0';
    }
    setWeeklyScheduleData(updatedData);
  };

  const handeOpenTime = (date, i, j) => {
    let updatedData = [...weeklyScheduleData];
    updatedData[i].lockData[j].openTime = date
      ? format(date, 'yyyy-MM-dd H:mm:ss')
      : '';
    setWeeklyScheduleData(updatedData);
  };
  const handeCloseTime = (date, i, j) => {
    let updatedData = [...weeklyScheduleData];
    updatedData[i].lockData[j].closeTime = date
      ? format(date, 'yyyy-MM-dd H:mm:ss')
      : '';
    setWeeklyScheduleData(updatedData);
  };
  const handeFirstBreakTime = (date, i, type) => {
    let updatedData = [...weeklyScheduleData];
    if (type === 's') {
      updatedData[i].fbsTime = date ? format(date, 'yyyy-MM-dd H:mm:ss') : '';
    } else {
      updatedData[i].fbeTime = date ? format(date, 'yyyy-MM-dd H:mm:ss') : '';
    }
    setWeeklyScheduleData(updatedData);
  };

  const handeSecBreakTime = (date, i, type) => {
    let updatedData = [...weeklyScheduleData];
    if (type === 's') {
      updatedData[i].sbsTime = date ? format(date, 'yyyy-MM-dd H:mm:ss') : '';
    } else {
      updatedData[i].sbeTime = date ? format(date, 'yyyy-MM-dd H:mm:ss') : '';
    }
    setWeeklyScheduleData(updatedData);
  };

  const handleBreakNameChange = (e, i, type) => {
    let updatedData = [...weeklyScheduleData];
    if (type === 'fbName') {
      updatedData[i].fbName = e.target.value;
    } else {
      updatedData[i].sbName = e.target.value;
    }
    setWeeklyScheduleData(updatedData);
  };

  const handeSaveProHrsData = () => {
    // Validate schedule dates for override/specific schedules
    if (scheduleType !== 0) {
      if (!scheduleStartDate || !scheduleEndDate) {
        setUiMessage(
          'err',
          'Schedule start date and end date are required for this schedule type.',
        );
        return;
      }
      if (new Date(scheduleStartDate) > new Date(scheduleEndDate)) {
        setUiMessage(
          'err',
          'Schedule end date cannot be before schedule start date.',
        );
        return;
      }
    }

    const weekdata = weeklyScheduleData?.some((item) =>
      item.lockData.some((lockData) => lockData.isClose === '1'),
    );
    if (!weekdata) {
      setUiMessage('err', 'Please select atleast one slot.');
      return;
    }

    // Validate individual day/location times and breaks
    for (const dayData of weeklyScheduleData) {
      for (const lockData of dayData.lockData) {
        if (lockData.isClose === '1') {
          // If the clinic is not closed
          if (!lockData.openTime || !lockData.closeTime) {
            setUiMessage(
              'err',
              `Open and close times are required for ${dayData.dayName} at location ${lockData.location_code}.`,
            );
            return;
          }
          if (new Date(lockData.openTime) >= new Date(lockData.closeTime)) {
            setUiMessage(
              'err',
              `Close time must be after open time for ${dayData.dayName} at location ${lockData.location_code}.`,
            );
            return;
          }
        }
      }

      // Validate first break times
      const hasAnyFbField =
        dayData.fbsTime || dayData.fbeTime || dayData.fbName;
      const hasAllFbFields =
        dayData.fbsTime && dayData.fbeTime && dayData.fbName;
      if (hasAnyFbField && !hasAllFbFields) {
        setUiMessage(
          'err',
          `First break start time, end time, and description are all required for ${dayData.dayName} if any one is provided.`,
        );
        return;
      }
      if (
        dayData.fbsTime &&
        dayData.fbeTime &&
        new Date(dayData.fbsTime) >= new Date(dayData.fbeTime)
      ) {
        setUiMessage(
          'err',
          `First break end time must be after first break start time for ${dayData.dayName}.`,
        );
        return;
      }

      // Validate second break times
      const hasAnySbField =
        dayData.sbsTime || dayData.sbeTime || dayData.sbName;
      const hasAllSbFields =
        dayData.sbsTime && dayData.sbeTime && dayData.sbName;
      if (hasAnySbField && !hasAllSbFields) {
        setUiMessage(
          'err',
          `Second break start time, end time, and description are all required for ${dayData.dayName} if any one is provided.`,
        );
        return;
      }
      if (
        dayData.sbsTime &&
        dayData.sbeTime &&
        new Date(dayData.sbsTime) >= new Date(dayData.sbeTime)
      ) {
        setUiMessage(
          'err',
          `Second break end time must be after second break start time for ${dayData.dayName}.`,
        );
        return;
      }
    }
    (async () => {
      const response = await post('api/auth/handleProviderWeeklySchedule', {
        provider: provider || user?.id,
        providerHoursData: weeklyScheduleData,
        scheduleStartDate: scheduleStartDate
          ? format(scheduleStartDate, 'yyyy-MM-dd')
          : '',
        scheduleEndDate: scheduleEndDate
          ? format(scheduleEndDate, 'yyyy-MM-dd')
          : '',
        scheduleType: scheduleType,
        overrideId: overrideId,
        loginUserId: user?.id,
      });
      if (response.status === 200) {
        if (response.data.msg === 'success') {
          reload();
        }
        handleClose();
      }
    })();
  };

  const handleDelete = () => {
    (async () => {
      try {
        const response = await post('api/auth/deleteProviderOverrideSchedule', {
          provider: provider,
          scheduleType: scheduleType,
          loginUserId: user?.id,
        });
        if (response.status === 200) {
          if (response.data.status === 'error') {
            setUiMessage('err', 'Something went wrong');
          } else {
            setScheduleStartDate(
              response.data?.sheduleStartDate
                ? new Date(response.data?.sheduleStartDate)
                : null,
            );
            setScheduleEndDate(
              response.data?.sheduleEndDate
                ? new Date(response.data?.sheduleEndDate)
                : null,
            );
            setOverrideId(
              response.data?.scheduleData
                ? response.data?.scheduleData?.override_id
                : 0,
            );
            const chkInptData =
              response.data?.proHours &&
              response.data?.proHours.reduce((acc, data, i) => {
                let finalObj = {
                  dayId: data?.dayId,
                  dayName: data?.dayName,
                  fbsTime: data?.fbs,
                  fbName: data?.fbName,
                  fbeTime: data?.fbe,
                  sbsTime: data?.sbs,
                  sbeTime: data?.sbe,
                  sbName: data?.sbName,
                };
                let obj = data.proHrsSetting.map((item, i) => {
                  return {
                    id: item?.id,
                    clinic_id: item?.clinic_id,
                    provider_id: item?.provider_id,
                    day_id: item?.day_id,
                    location_code: item?.location_code,
                    isClose: item?.is_closed,
                    openTime: item?.open_time,
                    closeTime: item?.close_time,
                    is_telemedicine: item?.is_telemedicine,
                  };
                });
                finalObj = { ...finalObj, lockData: obj };
                return [...acc, finalObj];
              }, []);
            setWeeklyScheduleData(chkInptData);
            reload();
          }
        }
      } catch (error) {
        setUiMessage('err', error?.message);
      }
    })();
  };

  const manageRecurrBlockData = async (task, actionType) => {
    if (task?.recurring_id !== '0') {
      try {
        const response = await post(
          'api/appointment/Appointment/showAskPopupForRecurringBlock',
          {
            taskId: task?.id, //taskId
            recurringId: task?.recurring_id,
            placeOfDel: '0',
            actionType: actionType, //0->change, 1->delete
          },
        );
        if (response.status === 200) {
          setAskRecurrData(response?.data);
          setRecurranceInstancePopup(true);
          setTaskData(task);
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    } else {
      if (actionType === '0') changeTask(task?.id, '0', '0');
      if (actionType === '1') handleDeleteTask(task, '0');
    }
  };

  const changeTask = async (taskId, recurrId, delType) => {
    try {
      const response = await post(
        'api/appointment/Appointment/changeThisTaskPop',
        {
          id: taskId, //taskId
          recurringId: recurrId,
          placeOfDel: '0',
          delType: delType, //'0' -> for one, '1' -> for all
        },
      );
      if (response?.status === 200) {
        setEditTaskData(response?.data);
        setUpdateInstanceFlag(delType);
        setAddTask(true);
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const handleDeleteTask = (task, val) => {
    setConFirmDelete((prev) => ({
      ...prev,
      status: true,
      deltaskData: task,
      delType: val,
    }));
  };

  const handleDeleteTempletConfirm = async (parms) => {
    const response = await post('api/appointment/appointment/deleteThisTask', {
      taskId: parms?.deltaskData?.id, //taskId
      recurringId: parms?.deltaskData?.recurring_id,
      placeOfDel: '0',
      delType: parms?.delType, //'0' -> for one, '1' -> for all
      loginUserId: user?.id,
    });
    if (response.status === 200) {
      if (response.data?.status === '1') {
        setUiMessage('suc', 'Task delete successfully');
        reload();
      } else {
        setUiMessage('err', 'Something went wrong. Unable to delete task.');
      }
    }
  };

  const atLeastOneSlotOpen = weeklyScheduleData?.some((item) =>
    item.lockData.some((lockData) => lockData.isClose === '1'),
  );

  const isSaveDisabled =
    scheduleType === 1
      ? !scheduleStartDate || !scheduleEndDate || !atLeastOneSlotOpen
      : !atLeastOneSlotOpen;

  return (
    <div className="modalBackground">
      <div className="weekly schedule-main-con ">
        <div className="pl-3 flex  items-center justify-between white-bg">
          <div className="fs-md fw-500 flex items-center gap-4">
            <span
              className="black-txt clear-right10"
              style={{ width: '250px', display: 'inline-block' }}
            >
              Weekly Schedule:
            </span>
            <span className="black-txt clear-right10">Resource:</span>
            <span className="">
              <select
                className="pe-msg-dd"
                style={{ width: '250px' }}
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
              >
                <option value="">All</option>
                {allData?.providers &&
                  allData?.providers.map((item, idx) => {
                    return (
                      <option key={idx} value={item?.id}>
                        {item?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
          </div>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="tabsData flex rounded-md bg-light p-1">
          <button
            className={`tabBtn flex-1 fs-xs p-2 fw-500 ${scheduleType === 0 ? 'active' : ''}`}
            onClick={() => setScheduleType(0)}
          >
            Regular Schedule
          </button>
          <button
            className={`tabBtn flex-1 fs-xs p-2 fw-500 ${scheduleType === 2 ? 'active' : ''}`}
            onClick={() => setScheduleType(2)}
          >
            Temporary Overrides
          </button>
          <button
            className={`tabBtn flex-1 fs-xs p-2 fw-500 ${scheduleType === 1 ? 'active' : ''}`}
            onClick={() => setScheduleType(1)}
          >
            Full Weekly Overrides
          </button>
        </div>
        {scheduleType === 0 || scheduleType === 1 ? (
          <>
            <div className="tabsData flex rounded-md bg-light p-1 justify-between">
              <div className="flex items-center gap-2">
                {scheduleType === 1 && (
                  <>
                    <span className="black-txt clear-right10">
                      Schedule Start Date:
                    </span>
                    <ReactDatePicker
                      selected={scheduleStartDate}
                      onChange={(date) => {
                        setScheduleStartDate(date);
                      }}
                      dateFormat={DEFAULT_DATE_FORMATE}
                      className="ws-time-inpt"
                    />
                  </>
                )}
                <span className="black-txt clear-right10">
                  Schedule End Date:
                </span>
                <ReactDatePicker
                  selected={scheduleEndDate}
                  onChange={(date) => {
                    setScheduleEndDate(date);
                  }}
                  dateFormat={DEFAULT_DATE_FORMATE}
                  className="ws-time-inpt"
                />
              </div>
              <div className="flex">
                {scheduleType === 1 &&
                  scheduleStartDate &&
                  scheduleEndDate &&
                  overrideId !== 0 && (
                    <Button onClick={() => handleDelete()} variant="danger">
                      Delete
                    </Button>
                  )}
              </div>
            </div>
            <div className="ws-hdr fontsize13">
              <span className="ws-hdr-lbl ws-col-1">Days</span>
              <span className="ws-hdr-lbl  ws-col-2">
                <span className="ws-col-3">Location</span>
                <span className="ws-col-3">Start</span>
                <span className="ws-col-3">End</span>
              </span>
            </div>
            <div className="ws-bdy fontsize13">
              {weeklyScheduleData &&
                weeklyScheduleData.map((item, i) => (
                  <div className="ws-bdy-prnt-rw" key={i}>
                    <span className="ws-hdr-lbl ws-col-1">{item?.dayName}</span>
                    <span className="ws-hdr-lbl  ws-col-2">
                      {item?.lockData.map((subSitem, j) => (
                        <div
                          className="ws-bdy-rw"
                          key={j}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <span className="ws-col-3 ws-hdr-lbl">
                            <input
                              type="checkbox"
                              className="clear-right10"
                              checked={subSitem?.isClose === '1' ? true : false}
                              onChange={(e) => handleChkBox(e, i, j)}
                              value={subSitem?.isClose}
                            />
                            {subSitem?.location_code}
                          </span>
                          {subSitem?.isClose === '1' ? (
                            <>
                              <span className="ws-col-3">
                                <ReactDatePicker
                                  selected={
                                    subSitem?.openTime
                                      ? new Date(subSitem?.openTime)
                                      : null
                                  }
                                  onChange={(date) => handeOpenTime(date, i, j)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={30}
                                  timeCaption="08:00 AM"
                                  // dateFormat="h:mm aa"
                                  dateFormat={
                                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                                      ? 'HH:mm'
                                      : 'h:mm aa'
                                  } // Conditional date format
                                  timeFormat={
                                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                                      ? 'HH:mm'
                                      : undefined
                                  } // Conditional time format
                                  className="ws-time-inpt"
                                  // minTime={
                                  //   subSitem?.openTime
                                  //     ? new Date(subSitem?.openTime)
                                  //     : null
                                  // }
                                  // maxTime={
                                  //   subSitem?.closeTime
                                  //     ? new Date(subSitem?.closeTime)
                                  //     : null
                                  // }
                                />
                              </span>
                              <span className="ws-col-3">
                                <ReactDatePicker
                                  selected={
                                    subSitem?.closeTime
                                      ? new Date(subSitem?.closeTime)
                                      : null
                                  }
                                  onChange={(date) =>
                                    handeCloseTime(date, i, j)
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={30}
                                  timeCaption="10:00 PM"
                                  // dateFormat="h:mm aa"
                                  dateFormat={
                                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                                      ? 'HH:mm'
                                      : 'h:mm aa'
                                  } // Conditional date format
                                  timeFormat={
                                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                                      ? 'HH:mm'
                                      : undefined
                                  } // Conditional time format
                                  className="ws-time-inpt"
                                  // minTime={
                                  //   subSitem?.openTime
                                  //     ? new Date(subSitem?.openTime)
                                  //     : null
                                  // }
                                  // maxTime={
                                  //   subSitem?.closeTime
                                  //     ? new Date(subSitem?.closeTime)
                                  //     : null
                                  // }
                                />
                              </span>
                              <span className="ws-col-3">
                                <input
                                  type="checkbox"
                                  className="clear-right10"
                                  checked={
                                    subSitem?.is_telemedicine === '1'
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => handleTelMedChkBox(e, i, j)}
                                />
                                Remote
                              </span>
                            </>
                          ) : (
                            <div className="bold weekly-off-str">
                              Weekly Off
                            </div>
                          )}
                        </div>
                      ))}

                      <div className="break-lbl">Break</div>
                      <div className="flex item-center ws-bdy-rw">
                        <span
                          className="ws-col-3 ws-hdr-lbl sec-colr"
                          style={{ width: '15%' }}
                        >
                          Break-1
                        </span>
                        <span className="ws-col-3" style={{ width: '20%' }}>
                          <ReactDatePicker
                            selected={
                              item?.fbsTime ? new Date(item?.fbsTime) : null
                            }
                            onChange={(date) =>
                              handeFirstBreakTime(date, i, 's')
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption=""
                            // dateFormat="h:mm aa"
                            dateFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : 'h:mm aa'
                            } // Conditional date format
                            timeFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : undefined
                            } // Conditional time format
                            className="ws-time-inpt"
                          />
                        </span>
                        <span className="ws-col-3" style={{ width: '20%' }}>
                          <ReactDatePicker
                            selected={
                              item?.fbeTime ? new Date(item?.fbeTime) : null
                            }
                            onChange={(date) =>
                              handeFirstBreakTime(date, i, 'e')
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption=""
                            // dateFormat="h:mm aa"
                            dateFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : 'h:mm aa'
                            } // Conditional date format
                            timeFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : undefined
                            } // Conditional time format
                            className="ws-time-inpt"
                          />
                        </span>
                        <span className="ws-col-3" style={{ width: '40%' }}>
                          Description:{' '}
                          <input
                            type="text"
                            className="ws-time-inpt"
                            style={{ width: '325px' }}
                            value={item?.fbName}
                            onChange={(e) =>
                              handleBreakNameChange(e, i, 'fbName')
                            }
                          />
                        </span>
                      </div>
                      <div className="flex item-center ws-bdy-rw">
                        <span
                          className="ws-col-3 ws-hdr-lbl sec-colr"
                          style={{ width: '15%' }}
                        >
                          Break-2
                        </span>
                        <span className="ws-col-3" style={{ width: '20%' }}>
                          <ReactDatePicker
                            selected={
                              item?.sbsTime ? new Date(item?.sbsTime) : null
                            }
                            onChange={(date) => handeSecBreakTime(date, i, 's')}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption=""
                            // dateFormat="h:mm aa"
                            dateFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : 'h:mm aa'
                            } // Conditional date format
                            timeFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : undefined
                            } // Conditional time format
                            className="ws-time-inpt"
                          />
                        </span>
                        <span className="ws-col-3" style={{ width: '20%' }}>
                          <ReactDatePicker
                            selected={
                              item?.sbeTime ? new Date(item?.sbeTime) : null
                            }
                            onChange={(date) => handeSecBreakTime(date, i, 'e')}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption=""
                            // dateFormat="h:mm aa"
                            dateFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : 'h:mm aa'
                            } // Conditional date format
                            timeFormat={
                              defaultTimeFormat?.withoutSecond === 'HH:mm'
                                ? 'HH:mm'
                                : undefined
                            } // Conditional time format
                            className="ws-time-inpt"
                          />
                        </span>
                        <span className="ws-col-3" style={{ width: '40%' }}>
                          Description:{' '}
                          <input
                            type="text"
                            className="ws-time-inpt"
                            style={{ width: '325px' }}
                            value={item?.sbName}
                            onChange={(e) =>
                              handleBreakNameChange(e, i, 'sbName')
                            }
                          />
                        </span>
                      </div>
                    </span>
                  </div>
                ))}
            </div>
            <div
              className="insu-act-sec-bdy-rw white-bg"
              style={{
                padding: '9px 0px 0px',
                display: 'inline-block',
                marginBottom: '0px',
              }}
            >
              <button
                className="actn-yes"
                style={{ width: '20%', opacity: isSaveDisabled ? 0.5 : 1 }}
                onClick={handeSaveProHrsData}
                disabled={isSaveDisabled}
              >
                Save
              </button>
              <button
                className="actn-No"
                style={{ width: '20%' }}
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div id="scheduleBlock" className="tabContainer scheduleWrapper">
            <div className="header flex justify-between mb-3">
              <div className="flex flex-col gap-1">
                <p className="text-gray fs-xs fw-500">
                  {allData?.providerName}
                </p>
                <div className="flex items-center gap-2">
                  <h2 className="fs-md fw-500">Temporary Overrides</h2>
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <button
                  className="btn-info fw-500 rounded-md"
                  onClick={() => setAddTask(true)}
                >
                  + Add Temporary Override
                </button>
              </div>
            </div>
            <div
              className="tabContent mt-4 rounded-md active"
              id="scheduleInnerBlock"
            >
              <div className="schedule">
                <div className="card-header mb-2 fs-md fw-500">Upcoming</div>
                {/* map start hear */}
                {allData?.tempUpcomingOverrideData &&
                  allData?.tempUpcomingOverrideData.map((item, idx) => {
                    return (
                      <div
                        className="schedule__type"
                        style={{ marginTop: '10px' }}
                        key={idx}
                      >
                        <div className="card-header mb-2">
                          <div className="title-section">
                            <div className="flex justify-between items-center title text-black fs-xs fw-500">
                              <span
                                className="title text-black fs-sm fw-500"
                                style={{
                                  float: 'left',
                                  padding: '5px 0px',
                                }}
                              >
                                {item?.task_description}
                              </span>

                              {Number(item?.blocked_flag) === 2 ? (
                                <span
                                  className="nw-ros-mid-colmn toggle-btn ml-3"
                                  style={{
                                    background: '#e6fcef',
                                    color: '#21b761',
                                    padding: '2px 10px',
                                    borderRadius: '21px',
                                    border: '1px solid #c5edd6',
                                  }}
                                >
                                  Open
                                </span>
                              ) : (
                                <span
                                  className="nw-ros-mid-colmn toggle-btn ml-3"
                                  style={{
                                    background: '#feeded',
                                    color: '#b91c1c',
                                    padding: '2px 10px',
                                    borderRadius: '21px',
                                    border: '1px solid #feeded',
                                  }}
                                >
                                  Blocked
                                </span>
                              )}
                            </div>
                            <div className="title text-black fs-xs fw-500">
                              {item?.newDate} - {item?.newDateEnd}
                            </div>
                            <div className="title text-black fs-xs fw-500">
                              {`${item?.convertedDateTime} - ${item?.convertedDateTimeEnd}`}
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <div
                              className="badge-status fw-500"
                              style={{ cursor: 'pointer', color: '#007bff' }}
                              onClick={() => {
                                manageRecurrBlockData(item, '0');
                              }}
                            >
                              Edit
                            </div>
                            <div
                              className="badge-status fw-500"
                              style={{ cursor: 'pointer', color: '#dc3545' }}
                              onClick={() => {
                                manageRecurrBlockData(item, '1');
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {/* map end */}
                <div
                  className="card-header mb-2 fs-md fw-500"
                  style={{ marginTop: '20px' }}
                >
                  Past
                </div>
                {/*past map start hear */}
                {allData?.tempPastOverrideData &&
                  allData?.tempPastOverrideData.map((item, idx) => {
                    return (
                      <div
                        className="schedule__type"
                        style={{ marginTop: '10px' }}
                        key={idx}
                      >
                        <div className="card-header mb-2">
                          <div className="title-section">
                            <div className="flex justify-between items-center title text-black fs-xs fw-500">
                              <span
                                className="title text-black fs-sm fw-500"
                                style={{
                                  float: 'left',
                                  padding: '5px 0px',
                                }}
                              >
                                {item?.task_description}
                              </span>

                              {Number(item?.blocked_flag) === 2 ? (
                                <span
                                  className="nw-ros-mid-colmn toggle-btn ml-3"
                                  style={{
                                    background: '#e6fcef',
                                    color: '#21b761',
                                    padding: '2px 10px',
                                    borderRadius: '21px',
                                    border: '1px solid #c5edd6',
                                  }}
                                >
                                  Open
                                </span>
                              ) : (
                                <span
                                  className="nw-ros-mid-colmn toggle-btn ml-3"
                                  style={{
                                    background: '#feeded',
                                    color: '#b91c1c',
                                    padding: '2px 10px',
                                    borderRadius: '21px',
                                    border: '1px solid #feeded',
                                  }}
                                >
                                  Blocked
                                </span>
                              )}
                            </div>
                            <div className="title text-black fs-xs fw-500">
                              {item?.newDate} - {item?.newDateEnd}
                            </div>
                            <div className="title text-black fs-xs fw-500">
                              {`${item?.convertedDateTime} - ${item?.convertedDateTimeEnd}`}
                            </div>
                          </div>
                          <div className="flex gap-2">
                            {/* <div
                              className="badge-status fw-500"
                              style={{ cursor: 'pointer', color: '#007bff' }}
                              onClick={() => {
                                manageRecurrBlockData(item, '0');
                              }}
                            >
                              Edit
                            </div> */}
                            <div
                              className="badge-status fw-500"
                              style={{ cursor: 'pointer', color: '#dc3545' }}
                              onClick={() => {
                                manageRecurrBlockData(item, '1');
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {/* past map end */}
              </div>
            </div>
          </div>
        )}
      </div>
      {addTask && (
        <AddTaskPopup
          //eventData={editTaskData}
          handleClose={() => {
            setAddTask(false);
          }}
          handleReload={() => reload()}
          eventData={editTaskData}
          recurrCheck={updateInstanceFlag} // to activate delete from task list
        />
      )}
      {recurranceInstancePopup && (
        <RecurranceUpdateInstancePopup
          handleClose={() => setRecurranceInstancePopup(false)}
          data={askRecurrData}
          callback={(val) => {
            if (askRecurrData?.statusTxt === 'Change')
              changeTask(taskData?.id, taskData?.recurring_id, val);
            if (askRecurrData?.statusTxt === 'Delete')
              handleDeleteTask(taskData, val);
          }}
        />
      )}

      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this task?"
          sucPrams={conFirmDelete}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={handleDeleteTempletConfirm}
        />
      )}
    </div>
  );
}

export default WeeklySchedule;
